import React from 'react'
import { Button, DropdownMenu, Flex } from '@workwhile/ui'
import { EllipsisVertical, Pencil, RotateCcw, Trash2 } from 'lucide-react'
import { createGlobalStyle } from 'styled-components'
import { useRequirementDetailContextValue } from '../context/RequirementDetailProvider'
import { useRequirementDetailWorkflowsContextValue } from '../context/RequirementDetailWorkflowProvider'

// Fix the z-index of the dropdown menu to appear above the table
// Radix poppers render in a portal, so we need a global style to fix the z-index
const DropdownZIndexFix = createGlobalStyle`
  [data-radix-popper-content-wrapper] {
    z-index: 100 !important;
  }
`

type ActionsCellProps = {
  question: ReturnType<
    typeof useRequirementDetailContextValue
  >['state']['questions'][number]
}

export const ActionsCell = ({ question }: ActionsCellProps) => {
  const { editQuestionFlow, removeQuestionFlow, restoreQuestionFlow } =
    useRequirementDetailWorkflowsContextValue()

  const isDeleted = question.deletedAt !== null

  const DeletedActions = () => (
    <DropdownMenu.Item onClick={() => restoreQuestionFlow.open({ question })}>
      <Flex gap={2} alignItems="center">
        <RotateCcw size={14} />
        Restore
      </Flex>
    </DropdownMenu.Item>
  )

  const UnDeletedActions = () => (
    <>
      <DropdownMenu.Item onClick={() => editQuestionFlow.open({ question })}>
        <Flex gap={2} alignItems="center">
          <Pencil size={14} />
          Edit
        </Flex>
      </DropdownMenu.Item>
      <DropdownMenu.Item onClick={() => removeQuestionFlow.open({ question })}>
        <Flex gap={2} alignItems="center">
          <Trash2 size={14} />
          Remove
        </Flex>
      </DropdownMenu.Item>
    </>
  )

  return (
    <>
      <DropdownZIndexFix />
      <Flex justifyContent="center" alignItems="center" width="100%">
        <DropdownMenu
          trigger={
            <Button variant="secondary" kind="small" px={1}>
              <EllipsisVertical size={14} />
            </Button>
          }
        >
          {isDeleted ? <DeletedActions /> : <UnDeletedActions />}
        </DropdownMenu>
      </Flex>
    </>
  )
}
